module.exports = __webpack_public_path__ + "static/media/Uxie_gaussian2.419c5c66.png";